import { useState } from "react";
import { faqs } from "@/mocks/manga";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-3xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-question-line"></i> FAQ
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            关于火影同人漫画在线看、免费阅读与无删减更新，你最关心的问题都在这。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div key={idx} className="overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70">
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-heading text-base font-bold text-foreground-950">{f.q}</h3>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"}`}>
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200/70 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}